import { DropdownBatch } from '@Features/dropdowns/dropdownsSlice.types';
import { CardTargetType, TARGET_LABELS } from './CardTarget';

/**
 * "1042 (Classroom: Physics 3A)" — the batch number plus what it was generated
 * for, shared by the Delete Codes and Edit Codes batch dropdowns. Falls back to
 * the bare number for responses without the annotation (older cached state).
 */
export const batchOptionLabel = (batch: DropdownBatch): string => {
	if (!batch.target_type) return String(batch.batch);
	const typeLabel =
		TARGET_LABELS[batch.target_type as Exclude<CardTargetType, null>] ??
		batch.target_type;
	return `${batch.batch} (${typeLabel}${
		batch.target_label ? `: ${batch.target_label}` : ''
	})`;
};
